import React from 'react'
import './editorActions.scss'

// Callers own their draft, save/recovery state, and action permissions.
export default function EditorActions({ dirty, pending, saved, saveLabel = 'Save changes', message = 'Changes are saved together.', validationMessage, children }) {
  const unsaved = dirty && !saved && !pending
  const invalid = Boolean(validationMessage) && !saved && !pending
  return <div className="editor-actions">
    <p role="status" className={`editor-actions-message ${unsaved || invalid ? 'text-danger' : 'text-muted'}`}>
      {pending ? 'Waiting for save confirmation…' : saved ? 'No unsaved changes.' : validationMessage || (unsaved
        ? `You have unsaved changes. Select ${saveLabel} to save them.` : message)}
    </p>
    <div className="editor-actions-buttons">{children}</div>
  </div>
}
